export const CUSTOM = 'custom'

export const PERIODS = [
  { value: '', label: 'Todos', days: 0 },
  { value: '7d', label: 'Últimos 7 dias', days: 7 },
  { value: '30d', label: 'Últimos 30 dias', days: 30 },
  { value: '90d', label: 'Últimos 90 dias', days: 90 },
  { value: CUSTOM, label: 'Personalizado', days: 0 },
]